module.exports = __webpack_public_path__ + "img/contact.1ddc7a38.png";